export function assertNever(input?: never) {
    throw new Error(`Expected ${JSON.stringify(input)} to be 'never'`);
}
